import {
    toast
} from "react-toastify";

export const successNotify = (text) => {
    return toast.success(text, {
        position: "top-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        // progress: 1
    })
}